<template>
  <li data-slot="pagination-item">
    <slot />
  </li>
</template>